module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-section",
    attrs: {
      "id": "mypage-myinfo-template joinstart"
    }
  }, [(!_vm.isAgree) ? _c('article', {
    staticClass: "board-view-wrap has-allChk"
  }, [_c('div', {
    staticClass: "text-box-section"
  }, [_c('div', {
    staticClass: "check-wrap all-Chk"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allAgree),
      expression: "allAgree"
    }],
    staticClass: "sr-only",
    attrs: {
      "type": "checkbox",
      "id": "allAgree",
      "name": "allAgree",
      "true-value": "true",
      "false-value": "false",
      "title": "전체 동의 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.allAgree) ? _vm._i(_vm.allAgree, null) > -1 : _vm._q(_vm.allAgree, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.allAgree,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allAgree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allAgree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allAgree = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p', {
    staticClass: "mt-16 color-gray"
  }, [_vm._v("본인은 본 “이용약관과 개인정보의 수집·이용 및 제3자 제공 동의서” 내용을 읽고 명확히 이해했으며, 이에 동의합니다.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "border-line-box wrap mt-40"
  }, [_c('div', {
    staticClass: "check-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.termAgree),
      expression: "termAgree"
    }],
    ref: "termAgree",
    staticClass: "sr-only",
    attrs: {
      "type": "checkbox",
      "id": "termAgree",
      "name": "termAgree",
      "true-value": "true",
      "false-value": "false",
      "title": "홈페이지 이용약관 동의 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.termAgree) ? _vm._i(_vm.termAgree, null) > -1 : _vm._q(_vm.termAgree, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.termAgree,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.termAgree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.termAgree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.termAgree = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "check-wrap mt-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.privacyAgree),
      expression: "privacyAgree"
    }],
    ref: "privacyAgree",
    staticClass: "sr-only",
    attrs: {
      "type": "checkbox",
      "id": "privacyAgree",
      "name": "privacyAgree",
      "true-value": "true",
      "false-value": "false",
      "title": "개인정보 수집 및 이용 동의 필수사항 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.privacyAgree) ? _vm._i(_vm.privacyAgree, null) > -1 : _vm._q(_vm.privacyAgree, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.privacyAgree,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.privacyAgree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.privacyAgree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.privacyAgree = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "check-wrap mt-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.privacyAgree2),
      expression: "privacyAgree2"
    }],
    staticClass: "sr-only",
    attrs: {
      "type": "checkbox",
      "id": "privacyAgree2",
      "name": "privacyAgree2",
      "true-value": "true",
      "false-value": "false",
      "title": "개인정보 수집 및 이용 동의 선택사항 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.privacyAgree2) ? _vm._i(_vm.privacyAgree2, null) > -1 : _vm._q(_vm.privacyAgree2, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.privacyAgree2,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.privacyAgree2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.privacyAgree2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.privacyAgree2 = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "check-wrap mt-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.privacyAgree3),
      expression: "privacyAgree3"
    }],
    staticClass: "sr-only",
    attrs: {
      "type": "checkbox",
      "id": "privacyAgree3",
      "name": "privacyAgree3",
      "true-value": "true",
      "false-value": "false",
      "title": "개인정보 수집 및 이용 동의 선택사항 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.privacyAgree3) ? _vm._i(_vm.privacyAgree3, null) > -1 : _vm._q(_vm.privacyAgree3, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.privacyAgree3,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.privacyAgree3 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.privacyAgree3 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.privacyAgree3 = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "check-wrap mt-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.privacyAgree4),
      expression: "privacyAgree4"
    }],
    staticClass: "sr-only",
    attrs: {
      "type": "checkbox",
      "id": "privacyAgree4",
      "name": "privacyAgree4",
      "true-value": "true",
      "false-value": "false",
      "title": "개인정보 수집 및 이용 동의 선택사항 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.privacyAgree4) ? _vm._i(_vm.privacyAgree4, null) > -1 : _vm._q(_vm.privacyAgree4, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.privacyAgree4,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.privacyAgree4 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.privacyAgree4 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.privacyAgree4 = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "check-wrap mt-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thirdPartyAgree),
      expression: "thirdPartyAgree"
    }],
    ref: "thirdPartyAgree",
    staticClass: "sr-only",
    attrs: {
      "type": "checkbox",
      "id": "thirdPartyAgree",
      "name": "thirdPartyAgree",
      "true-value": "true",
      "false-value": "false",
      "title": "개인정보의 제3자 제공 동의 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.thirdPartyAgree) ? _vm._i(_vm.thirdPartyAgree, null) > -1 : _vm._q(_vm.thirdPartyAgree, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.thirdPartyAgree,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.thirdPartyAgree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.thirdPartyAgree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.thirdPartyAgree = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "check-wrap mt-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resumeAgree),
      expression: "resumeAgree"
    }],
    ref: "resumeAgree",
    staticClass: "sr-only",
    attrs: {
      "type": "checkbox",
      "id": "resumeAgree",
      "name": "resumeAgree",
      "true-value": "true",
      "false-value": "false",
      "title": "나의 이력서 정보 제공 동의 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.resumeAgree) ? _vm._i(_vm.resumeAgree, null) > -1 : _vm._q(_vm.resumeAgree, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.resumeAgree,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.resumeAgree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.resumeAgree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.resumeAgree = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _vm._m(14)])]) : _vm._e(), _vm._v(" "), (!_vm.isAgree) ? _c('div', {
    staticClass: "button-area flex-end mt-40"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-md",
    attrs: {
      "type": "button",
      "title": "다음으로"
    },
    on: {
      "click": _vm.agreeConfirm
    }
  }, [_vm._v("\n      다음으로\n    ")])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn && _vm.isAgree) ? _c('div', {
    staticClass: "table-wrap join-info-wrap"
  }, [_vm._m(15), _vm._v(" "), _c('table', {
    staticClass: "table-body-only mt-16"
  }, [_c('caption', {
    staticClass: "ir-text"
  }, [_vm._v("회원가입 정보입력")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(18), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area wid100p has-button"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginid),
      expression: "loginid"
    }],
    staticStyle: {
      "text-transform": "lowercase"
    },
    attrs: {
      "type": "text",
      "placeholder": "아이디를 입력해 주세요.",
      "id": "loginid",
      "aria-describedby": "id-guide",
      "title": "아이디 입력"
    },
    domProps: {
      "value": (_vm.loginid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginid = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.aleadyHave) ? _c('button', {
    staticClass: "btn btn-primary btn-xsm",
    attrs: {
      "type": "button",
      "title": "아이디 중복확인"
    },
    on: {
      "click": _vm.confirmId
    }
  }, [_vm._v("\n              중복확인\n            ")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "join-info-text mt-16",
    attrs: {
      "id": "id-guide"
    }
  }, [_vm._v("* 아이디는 중복확인 후 사용 가능합니다.")])])]), _vm._v(" "), _c('tr', [_vm._m(19), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area wid100p"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "비밀번호를 입력해 주세요.",
      "id": "password",
      "aria-describedby": "pw-guide",
      "title": "비밀번호 입력"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(20)])]), _vm._v(" "), _c('tr', [_vm._m(21), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area wid100p"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirm),
      expression: "passwordConfirm"
    }],
    attrs: {
      "type": "password",
      "placeholder": "비밀번호를 입력해 주세요.",
      "id": "passwordconfirm",
      "title": "비밀번호 확인 입력"
    },
    domProps: {
      "value": (_vm.passwordConfirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirm = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_vm._m(22), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area wid100p"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "이름을 입력해 주세요.",
      "id": "name",
      "title": "이름 입력"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_vm._m(23), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-group phone-group"
  }, [_c('div', {
    staticClass: "items1"
  }, [_c('div', {
    staticClass: "input-area wid100"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.birthYYYY),
      expression: "birthYYYY"
    }],
    attrs: {
      "title": "년도 선택",
      "id": "birthYYYY",
      "aria-labelledby": "label-birth birthYYYY"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.birthYYYY = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("년도 선택")]), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return _c('option', {
      key: year,
      domProps: {
        "selected": _vm.birthYYYY === year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "items2"
  }, [_c('div', {
    staticClass: "input-area wid100"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.birthMM),
      expression: "birthMM"
    }],
    attrs: {
      "title": "월 선택",
      "id": "birthMM",
      "aria-labelledby": "label-birth birthMM"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.birthMM = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("월 선택")]), _vm._v(" "), _vm._l((_vm.months), function(month) {
    return _c('option', {
      key: month,
      domProps: {
        "selected": _vm.birthMM === month
      }
    }, [_vm._v(_vm._s(month))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "input-area wid100"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.birthDD),
      expression: "birthDD"
    }],
    attrs: {
      "title": "일 선택",
      "id": "birthDD",
      "aria-labelledby": "label-birth birthDD"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.birthDD = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("일 선택")]), _vm._v(" "), _vm._l((_vm.days), function(day) {
    return _c('option', {
      key: day,
      domProps: {
        "selected": _vm.birthDD === day
      }
    }, [_vm._v(_vm._s(day))])
  })], 2)])])])])]), _vm._v(" "), _c('tr', [_vm._m(24), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex gap10",
    attrs: {
      "role": "group",
      "aria-labelledby": "label-gender"
    }
  }, _vm._l((_vm.genderList), function(key, value) {
    return _c('label', {
      key: value,
      staticClass: "radio-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gender),
        expression: "gender"
      }],
      staticClass: "sr-only",
      attrs: {
        "type": "radio",
        "name": "inlineRadioOptions",
        "aria-label": '성별, ' + key
      },
      domProps: {
        "value": value,
        "checked": _vm._q(_vm.gender, value)
      },
      on: {
        "change": function($event) {
          _vm.gender = value
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-radio"
    }), _vm._v("\n              " + _vm._s(key) + "\n            ")])
  }), 0)])]), _vm._v(" "), _c('tr', [_vm._m(25), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-group email-group"
  }, [_c('div', {
    staticClass: "items1"
  }, [_c('div', {
    staticClass: "input-area wid120"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email1),
      expression: "email1"
    }],
    attrs: {
      "type": "text",
      "placeholder": "1234",
      "id": "email1",
      "title": "이메일 계정"
    },
    domProps: {
      "value": (_vm.email1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dash"
  }, [_vm._v("@")])]), _vm._v(" "), _c('div', {
    staticClass: "items2"
  }, [_c('div', {
    staticClass: "input-area wid120"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email2),
      expression: "email2"
    }],
    attrs: {
      "id": "emailSelectBox",
      "title": "이메일 도메인 선택"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.email2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.emailChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("선택")]), _vm._v(" "), _vm._l((_vm.emailList), function(list) {
    return _c('option', {
      key: list,
      domProps: {
        "value": list
      }
    }, [_vm._v(_vm._s(list))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "etc"
    }
  }, [_vm._v("직접입력")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "input-area wid120"
  }, [(_vm.email2 === 'etc') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.etcEmailAddress),
      expression: "etcEmailAddress"
    }],
    attrs: {
      "type": "text",
      "placeholder": "email.com",
      "id": "emailSelectBoxDirect",
      "title": "이메일 도메인 직접입력"
    },
    domProps: {
      "value": (_vm.etcEmailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.etcEmailAddress = $event.target.value
      }
    }
  }) : _vm._e()])])])])]), _vm._v(" "), _c('tr', [_vm._m(26), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-group phone-group",
    attrs: {
      "role": "group",
      "aria-labelledby": "label-phone"
    }
  }, [_c('div', {
    staticClass: "items1"
  }, [(this.sessionHp === '') ? _c('div', {
    staticClass: "input-area wid120"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone1),
      expression: "phone1"
    }],
    attrs: {
      "title": "휴대폰 앞자리",
      "id": "phone1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.phone1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("010")])])]) : _vm._e(), _vm._v(" "), (this.sessionHp !== '') ? _c('div', {
    staticClass: "input-area wid120"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone1),
      expression: "phone1"
    }],
    attrs: {
      "type": "text",
      "title": "휴대폰 앞자리",
      "placeholder": "1234",
      "readonly": this.sessionHp === '' ? false : true
    },
    domProps: {
      "value": (_vm.phone1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone1 = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dash",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('div', {
    staticClass: "items2"
  }, [_c('div', {
    staticClass: "input-area wid120"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone2),
      expression: "phone2"
    }],
    attrs: {
      "type": "text",
      "placeholder": "1234",
      "title": "휴대폰 중간자리",
      "readonly": this.sessionHp === '' ? false : true
    },
    domProps: {
      "value": (_vm.phone2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dash",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "input-area wid120"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone3),
      expression: "phone3"
    }],
    attrs: {
      "type": "text",
      "placeholder": "1234",
      "title": "휴대폰 뒷자리",
      "readonly": this.sessionHp === '' ? false : true
    },
    domProps: {
      "value": (_vm.phone3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone3 = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('tr', [_vm._m(27), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "address-wrap"
  }, [_c('div', {
    staticClass: "input-group post-code"
  }, [_c('div', {
    staticClass: "input-area wid200"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zipcode),
      expression: "zipcode"
    }],
    attrs: {
      "type": "text",
      "id": "postcode",
      "readonly": "",
      "title": "우편번호"
    },
    domProps: {
      "value": (_vm.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zipcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    ref: "findPostCode",
    staticClass: "btn btn-primary btn-xsm",
    attrs: {
      "type": "button",
      "id": "findPostCode",
      "title": "우편번호 검색"
    },
    on: {
      "click": _vm.findAddress
    }
  }, [_vm._v("\n                우편번호 검색\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticStyle: {
      "display": "none",
      "border": "1px solid",
      "width": "396px",
      "height": "300px",
      "margin": "5px 0",
      "position": "relative",
      "overflow": "hidden"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('img', {
    staticStyle: {
      "outline-color": "red",
      "cursor": "pointer",
      "position": "absolute",
      "right": "0px",
      "top": "0px",
      "z-index": "1"
    },
    attrs: {
      "src": "//t1.daumcdn.net/localimg/localimages/07/postcode/320/close.png",
      "tabindex": "0",
      "id": "btnFoldWrap",
      "alt": "우편번호 검색창 접기 버튼",
      "role": "button"
    },
    on: {
      "click": _vm.foldDaumPostcode,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.foldDaumPostcode.apply(null, arguments)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-area wid100p"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addr1),
      expression: "addr1"
    }],
    ref: "addr1",
    attrs: {
      "type": "text",
      "title": "기본주소",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addr1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addr1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-area wid100p"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addr2),
      expression: "addr2"
    }],
    ref: "addr2",
    attrs: {
      "type": "text",
      "id": "addr2",
      "title": "상세주소 입력",
      "aria-label": "상세주소"
    },
    domProps: {
      "value": (_vm.addr2)
    },
    on: {
      "keyup": _vm.checked,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addr2 = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('tr', [_vm._m(28), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area mo-size wid400"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channel),
      expression: "channel"
    }],
    attrs: {
      "title": "가입경로",
      "id": "joinChannel"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.channel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.channelChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "지인소개"
    }
  }, [_vm._v("지인소개")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50+재단/캠퍼스/센터"
    }
  }, [_vm._v("50+재단/캠퍼스/센터")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "서울시 유관홈페이지"
    }
  }, [_vm._v("서울시 유관홈페이지")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "언론보도"
    }
  }, [_vm._v("언론보도(신문, 방송, 라디오 등)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "옥외광고"
    }
  }, [_vm._v("옥외광고(지하철, 버스, 현수막 등)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "타 기관 안내"
    }
  }, [_vm._v("타 기관 안내")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "홍보책자"
    }
  }, [_vm._v("홍보책자(포스터, 전단지, 리플릿 등)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "인터넷/SNS 검색"
    }
  }, [_vm._v("인터넷/SNS 검색(페이스북 등)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "미디어광고"
    }
  }, [_vm._v("미디어광고(신문잡지, 라디오광고 등)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "etc"
    }
  }, [_vm._v("기타")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-area mo-size wid400"
  }, [(_vm.channel === 'etc') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelEtc),
      expression: "channelEtc"
    }],
    attrs: {
      "type": "text",
      "id": "joinChannelEtc",
      "maxlength": "30",
      "placeholder": "입력해주세요.",
      "title": "가입경로 기타 입력"
    },
    domProps: {
      "value": (_vm.channelEtc)
    },
    on: {
      "keyup": _vm.checked,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.channelEtc = $event.target.value
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', [_vm._m(29), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area mo-size wid400"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motive),
      expression: "motive"
    }],
    attrs: {
      "title": "가입동기 및 희망분야",
      "id": "joinMotive"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.motive = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.motiveChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "인생후반전 준비에 대한 인식을 가지고자"
    }
  }, [_vm._v("인생후반전 준비에 대한 인식을 가지고자")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "사회공헌 및 자원봉사에 관심이 있어서"
    }
  }, [_vm._v("사회공헌 및 자원봉사에 관심이 있어서")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NGO 등 인생후반전을 위한 단체를 구성하기 위해서"
    }
  }, [_vm._v("NGO 등 인생후반전을 위한 단체를 구성하기 위해서")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "창업을 위해서"
    }
  }, [_vm._v("창업을 위해서")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "재취업을 위해서"
    }
  }, [_vm._v("재취업을 위해서")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "생각이나 취미가 같은 사람들을 만나기 위해"
    }
  }, [_vm._v("생각이나 취미가 같은 사람들을 만나기 위해")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "etc"
    }
  }, [_vm._v("기타")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-area mo-size wid400"
  }, [(_vm.motive === 'etc') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motiveEtc),
      expression: "motiveEtc"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "joinMotiveEtc",
      "maxlength": "30",
      "placeholder": "입력해주세요.",
      "title": "가입동기 및 희망분야 기타 입력"
    },
    domProps: {
      "value": (_vm.motiveEtc)
    },
    on: {
      "keyup": _vm.checked,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motiveEtc = $event.target.value
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', [_vm._m(30), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "interest-grid",
    attrs: {
      "role": "group",
      "aria-labelledby": "label-interest-orgs"
    }
  }, [_c('div', {
    staticClass: "check-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allCheck),
      expression: "allCheck"
    }],
    staticClass: "sr-only",
    attrs: {
      "type": "checkbox",
      "id": "like-orgs",
      "name": "inlineRadioOptions",
      "aria-label": "나의 관심 50+ 기관, 전체"
    },
    domProps: {
      "checked": Array.isArray(_vm.allCheck) ? _vm._i(_vm.allCheck, null) > -1 : (_vm.allCheck)
    },
    on: {
      "click": _vm.chkAllOrgs,
      "change": function($event) {
        var $$a = _vm.allCheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allCheck = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allCheck = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(31)]), _vm._v(" "), _vm._l((_vm.likeOrgCheckBoxList), function(org) {
    return _c('div', {
      key: org.code,
      staticClass: "check-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.likeOrgs),
        expression: "likeOrgs"
      }],
      staticClass: "sr-only",
      attrs: {
        "type": "checkbox",
        "aria-label": '나의 관심 50+ 기관, ' + org.name,
        "id": 'like_' + org.code
      },
      domProps: {
        "value": org.code,
        "checked": Array.isArray(_vm.likeOrgs) ? _vm._i(_vm.likeOrgs, org.code) > -1 : (_vm.likeOrgs)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.likeOrgs,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = org.code,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.likeOrgs = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.likeOrgs = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.likeOrgs = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'like_' + org.code
      }
    }, [_c('span', [_vm._v(_vm._s(org.name))])])])
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "interest-note mt-16"
  }, [_vm._v("*관심 50+ 기관의 소식(문자, 뉴스레터)을 받을 수 있습니다.")])])]), _vm._v(" "), _c('tr', [_vm._m(32), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area wid100p"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occuPationStr),
      expression: "occuPationStr"
    }],
    attrs: {
      "id": "occuPationSelect",
      "title": "주된 직업군 선택"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.occuPationStr = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onOccuPationChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("선택하세요")]), _vm._v(" "), _vm._l((_vm.occuList), function(occu, index) {
    return _c('option', {
      key: index,
      attrs: {
        "title": occu
      },
      domProps: {
        "value": occu
      }
    }, [_vm._v("\n                " + _vm._s(occu) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "input-area mo-size mt-8"
  }, [(_vm.occuPationStr === '기타') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occuEtcVal),
      expression: "occuEtcVal"
    }],
    attrs: {
      "type": "text",
      "size": "12",
      "maxlength": "12",
      "id": "occuEtc",
      "title": "주된 직업군 기타 내용 입력란"
    },
    domProps: {
      "value": (_vm.occuEtcVal)
    },
    on: {
      "keyup": _vm.checked,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.occuEtcVal = $event.target.value
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row",
      "id": "label-email-receive"
    }
  }, [_vm._v("Email 수신")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex gap10",
    attrs: {
      "role": "group",
      "aria-labelledby": "label-email-receive"
    }
  }, _vm._l((_vm.emailCheckList), function(key, value) {
    return _c('label', {
      key: value,
      staticClass: "radio-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.emailCheck),
        expression: "emailCheck"
      }],
      staticClass: "sr-only",
      attrs: {
        "type": "radio",
        "name": "inlineRadioOptions1",
        "aria-label": 'Email 수신 여부, ' + key
      },
      domProps: {
        "value": value,
        "checked": _vm._q(_vm.emailCheck, value)
      },
      on: {
        "change": function($event) {
          _vm.emailCheck = value
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-radio"
    }), _vm._v("\n              " + _vm._s(key) + "\n            ")])
  }), 0), _vm._v(" "), _vm._m(33)])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row",
      "id": "label-sms-receive"
    }
  }, [_vm._v("SMS 수신")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex gap10",
    attrs: {
      "role": "group",
      "aria-labelledby": "label-sms-receive"
    }
  }, _vm._l((_vm.smsCheckList), function(key, value) {
    return _c('label', {
      key: value,
      staticClass: "radio-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.smsCheck),
        expression: "smsCheck"
      }],
      staticClass: "sr-only",
      attrs: {
        "type": "radio",
        "name": "inlineRadioOptions2",
        "aria-label": 'SMS 수신 여부, ' + key
      },
      domProps: {
        "value": value,
        "checked": _vm._q(_vm.smsCheck, value)
      },
      on: {
        "change": function($event) {
          _vm.smsCheck = value
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-radio"
    }), _vm._v("\n              " + _vm._s(key) + "\n            ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "button-area flex-justify-center mt-32"
  }, [_c('a', {
    staticClass: "btn btn-primary wid100p btn-md",
    attrs: {
      "href": "javascript:void(0)",
      "role": "button",
      "title": "가입하기"
    },
    on: {
      "click": _vm.join
    }
  }, [_vm._v("\n        가입하기\n      ")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "allAgree"
    }
  }, [_c('span', [_c('strong', [_vm._v("전체 동의")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "termAgree"
    }
  }, [_c('span', [_c('strong', [_vm._v("[필수] 홈페이지 이용약관 동의")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-wrap mt-16"
  }, [_vm._v("\n        [제 1 장 총 칙]"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 1 조 (목적)"), _c('br'), _vm._v("\n        이 약관은 서울시 50플러스재단, 캠퍼스, 센터 (이하 \"재단\"이라 함)이 운영하는 웹사이트(이하 “사이트”)에서 제공하는 인터넷 관련 홈페이지 서비스(이하 \"서비스\")를 이용함에 있어서 사이트와\n        이용자 사이의 의무 및 책임사항, 하나의 ID 및 PASSWORD로 통합하여 이용하는데 따른 이용조건 및 절차 등 기본적인 사항을 규정함을 목적으로 합니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 2 조 (약관의 명시 및 개정)"), _c('br'), _vm._v("\n        ① 이 약관은 재단이 인터넷 홈페이지 화면 또는 지면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다. "), _c('br'), _vm._v("\n        ② 재단은 필요에 따라 이 약관을 개정할 수 있으며 변경된 약관은 1항과 같은 방법으로 공지함으로써 효력이 발생합니다. "), _c('br'), _vm._v("\n        ③ 이용자는 변경된 약관에 동의하지 않으실 경우 서비스 이용을 중단하고 본인의 회원등록을 취소할 수 있으며, 변경된 약관의 효력 발생일 이후의 계속적인 서비스 이용은 변경 약관에 동의한 것으로\n        간주합니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 3 조 (약관 외 준칙)"), _c('br'), _vm._v("\n        이 약관에 명시되지 않은 사항과 이 약관의 해석은 개인정보보호법, 전기통신기본법, 전기통신사업법, 정보통신망이용촉진및정보보호등에관한법률, 방송통신심의위원회 심의규정, 정보통신 윤리강령, 프로그램\n        보호법 등 기타 대한민국의 관련법령과 상관습에 의합니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 4 조 (용어의 정의)"), _c('br'), _vm._v("\n        이 약관에서 사용하는 용어의 정의는 다음과 같습니다."), _c('br'), _vm._v("\n        ① 사이트 : 재단이 서비스를 이용자에게 제공하기 위하여 운영하는 사이트를 말하며, 통합된 하나의 계정(ID 및 PASSWORD)을 이용하여 서비스를 제공받을 수 있는 아래의 사이트를 의미하기도\n        합니다."), _c('br'), _vm._v("\n        1. 서울시 50플러스 재단 공식 홈페이지 : www.50plus.or.kr"), _c('br'), _vm._v("\n        2. 그 외 홈페이지별 하위 도메인 홈페이지 포함(일자리몽땅, 라이프몽땅, 자치구센터)"), _c('br'), _vm._v("\n        ② 이용자 : 재단의 이용약관에 따라 사이트가 제공하는 서비스를 받는 회원 또는 비회원을 말합니다."), _c('br'), _vm._v("\n        ③ 회원 : 재단의 이용약관에 동의하고, 개인정보를 제공하여 회원으로 등록하고 승인받은 자로서, 재단이 제공하는 로그인 서비스를 이용할 수 있는 자를 말합니다."), _c('br'), _vm._v("\n        ④ 비회원 : 회원등록을 하지 않고 사이트가 제공하는 서비스를 이용하는 자를 말합니다."), _c('br'), _vm._v("\n        ⑤ ID(고유번호) : 회원식별과 회원 서비스 이용을 위하여 회원이 신청하고 재단이 승인하는 문자 및 숫자의 조합을 말합니다."), _c('br'), _vm._v("\n        ⑥ PASSWORD(비밀번호) : 회원이 부여받은 ID와 일치된 회원임을 확인하고 회원의 비밀보호를 위하여 회원 자신이 선정한 문자와 숫자의 조합을 말합니다."), _c('br'), _vm._v("\n        ⑦ 탈퇴(이용해지) : 회원이 이용계약을 종료시키는 의사표시를 말합니다. "), _c('br'), _vm._v("\n        ⑧ 본 약관에서 정의하지 않은 용어는 개별서비스에 대한 별도 약관 및 이용규정에서 정의 합니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        [제 2 장 서비스의 이용계약]"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 5 조 (신청) "), _c('br'), _vm._v("\n        ① 회원이 되고자하는 이용자는 온라인을 통하여 회원가입 페이지의 ‘동의함’ 체크를 눌러 홈페이지의 본 약관 내용에 대한 동의표시를 합니다."), _c('br'), _vm._v("\n        ② 본 약관에 동의한 이용자는 재단이 마련한 본인확인 절차를 거치며, 만 14세 미만의 경우는 법정대리인의 동의가 필요합니다."), _c('br'), _vm._v("\n        ③ 재단과 이용자간의 서비스 이용계약은 본인확인 절차를 거친 이용자가 웹사이트에서 제공하는 양식에 따른 기록을 통해 회원가입을 완료하고, 재단의 승인으로 성립되어 회원의 자격을 취득합니다."), _c('br'), _vm._v("\n        ④ 이용자는 사이트의 회원 가입화면에서 다음의 서비스를 원하는 경우 선택하여 신청할 수 있습니다."), _c('br'), _vm._v("\n        1. 수신동의(E-mail / SMS)"), _c('br'), _vm._v("\n        2. 가입동의(서울시 50플러스 재단)"), _c('br'), _vm._v("\n        ⑤ 재단은 제1장 제4조 제1항에 명기한 사이트의 원활한 서비스를 이용하기 위해 필요한 추가정보를 이용자 동의절차를 통해 요구할 수 있습니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 6 조 (계약의 성립) "), _c('br'), _vm._v("\n        ① 재단은 제2장 제1조에서 정한 사항을 정확히 기재하여 이용신청을 하였을 경우 특별한 사정이 없는 한 서비스 이용신청을 승낙합니다."), _c('br'), _vm._v("\n        ② 재단은 다음 각 호에 해당하는 경우에 한하여 이용신청을 승낙하지 않을 수 있습니다. "), _c('br'), _vm._v("\n        1. 본인인증이 되지 않거나 이미 이용신청중인 타인의 정보와 중복되는 경우"), _c('br'), _vm._v("\n        2. 만14세 미만의 경우, 법정대리인의 동의가 없는 경우"), _c('br'), _vm._v("\n        3. 기타 홈페이지가 정한 회원가입 요건을 충족하지 못하였을 경우"), _c('br'), _vm._v("\n        ③ 재단은 다음 각 항에 해당하는 경우 그 사유가 해소될 때까지 이용계약 성립을 유보 또는 일부 서비스 이용을 제한할 수 있습니다."), _c('br'), _vm._v("\n        1. 서비스 관련 설비의 용량이 부족한 경우"), _c('br'), _vm._v("\n        2. 기술상 장애 사유가 있는 경우"), _c('br'), _vm._v("\n        3. 기타 재단의 사정상 필요하다고 인정되는 경우"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 7 조 (회원의 유효기간)"), _c('br'), _vm._v("\n        ① 회원의 유효기간은 이용계약의 성립 시부터 이용자의 의사에 의한 계약의 해지 시까지입니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 8 조 (회원에게 제공되는 서비스) "), _c('br'), _vm._v("\n        ① 재단이 제공하는 로그인 서비스를 이용할 수 있습니다."), _c('br'), _vm._v("\n        ② 재단의 각종 행사 정보를 E-mail을 통해 제공 받을 수 있으며, 각 재단별 발행 뉴스레터를 통해 행사를 홍보 할 수 있습니다."), _c('br'), _vm._v("\n        ③ 홈페이지 이벤트 참여기회 부여됩니다."), _c('br'), _vm._v("\n        ④ 배움(특강, 창업교육) "), _c('br'), _vm._v("\n        ⑤ 커뮤니티관리시스템"), _c('br'), _vm._v("\n        ⑥ 가치동행일자리, 취업훈련, 경력인재지원, 채용설명회"), _c('br'), _vm._v("\n        ⑦ 대관관리시스템"), _c('br'), _vm._v("\n        ⑧ 상담관리시스템"), _c('br'), _vm._v("\n        ⑨ 기타 재단 관련 행사 참여 및 정보를 우선적으로 제공해 드립니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 9 조 (통합회원제)"), _c('br'), _vm._v("\n        ① 회원은 통합된 하나의 계정(ID 및 비밀번호)을 통해 본 약관 제1장 제4조 제1항에 명기한 캠퍼스, 센터, 교육 사이트의 서비스를 별도의 회원가입 없이 이용할 수 있습니다."), _c('br'), _vm._v("\n        ② 통합ID는 원칙적으로 변경이 불가하며 부득이한 사유로 인하여 변경하고자 하는 경우에는 해당 회원등록을 탈퇴(해지)하고 재가입해야 합니다. "), _c('br'), _vm._v("\n        (※단, 탈퇴(해지)한 회원은 기존 통합ID로 서비스를 이용할 수 없습니다.)"), _c('br'), _vm._v("\n        ③ 회원은 등록된 본인의 회원정보가 변경된 경우, 즉시 변경된 내용으로 회원정보를 수정하여야 하며, 재단은 회원이 변경사항을 수정하지 아니하여 발생하는 불이익에 대하여 책임지지 않습니다."), _c('br'), _vm._v("\n        ④ 통합ID 분실 시 본인 확인 과정을 거친 후 홈페이지를 통해 통합ID를 확인할 수 있도록 제공합니다."), _c('br'), _vm._v("\n        ⑤ 비밀번호 분실 시 본인 확인 과정을 거친 후 가입 시 기입한 이메일 주소를 통해 임시 비밀번호를 제공합니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        [제 3 장 계약 해지 및 서비스 이용제한 ]"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 10 조 (회원탈퇴 및 자격 상실) "), _c('br'), _vm._v("\n        ① 회원은 회원가입 이후 홈페이지에서 제공하는 서비스를 제공받을 의사를 철회하고자 하는 경우에는 언제든지 “회원탈퇴” 메뉴를 이용하여 탈퇴를 요청할 수 있으며 재단은 즉시 회원탈퇴를 처리합니다.\n        다만, 재단에 제공한 수강정보, 결제정보, 커뮤니티, 일자리 정보 등 관련정보는 회원의 별도 삭제처리 요청이 없을 경우 계속하여 제공됩니다."), _c('br'), _vm._v("\n        * 전자상거래 등에서의 소비자보호에 관한 법률 제 6조에 의거 성명·주소·전자우편주소 등 거래의 주체를 식별할 수 있는 정보에 한하여 이용자가 개인정보의 이용에 관한 동의를 철회하는 경우에도\n        「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 대통령령으로 정하는 개인정보보호와 관련된 법률의 규정에도 불구하고 이를 보존할 수 있다"), _c('br'), _vm._v("\n        1. 표시·광고에 관한 기록: 6개월"), _c('br'), _vm._v("\n        2. 계약 또는 청약철회 등에 관한 기록: 5년"), _c('br'), _vm._v("\n        3. 대금결제 및 재화등의 공급에 관한 기록: 5년"), _c('br'), _vm._v("\n        4. 소비자의 불만 또는 분쟁처리에 관한 기록: 3년"), _c('br'), _vm._v("\n        (개인정보의 이용에 관한 동의를 철회한 소비자의 거래기록 및 개인정보를 보존하는 경우에는 개인정보의 이용에 관한 동의를 철회하지 아니한 소비자의 거래기록 및 개인정보와 별도로 보존할 것)"), _c('br'), _vm._v("\n        ② 회원이 다음 각 호의 사유에 해당하는 경우 재단은 회원자격을 제한 및 정지, 취소시킬 수 있습니다."), _c('br'), _vm._v("\n        1. 다른 사람의 명의를 사용하여 신청하였을 경우"), _c('br'), _vm._v("\n        2. 신청서의 내용을 허위로 기재한 사실이 발견된 경우"), _c('br'), _vm._v("\n        3. 다른 사람의 홈페이지 서비스 이용을 방해하거나 다른 사람의 정보를 도용하는 등의 행위를 하였을 경우"), _c('br'), _vm._v("\n        4. 홈페이지를 이용하여 법령과 본 약관이 금지하는 행위를 하는 경우"), _c('br'), _vm._v("\n        5. 사회의 안녕 질서 또는 미풍양속을 저해할 목적으로 신청하였을 경우"), _c('br'), _vm._v("\n        ③ 재단은 각 홈페이지별 회원을 통합 운영하고 있으므로 통합회원을 탈퇴하면 재단에서 서비스 중인 홈페이지에 로그인할 수 없습니다. "), _c('br'), _vm._v("\n        ④ 개별 홈페이지가 폐쇄 또는 양도되었을 경우에는 서비스 대상만 삭제되며 개별 홈페이지를 통해 회원가입을 한 회원을 대상으로 통합회원 탈퇴가 이루어지지는 않습니다. "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 11 조 (계약사항의 변경) "), _c('br'), _vm._v("\n        ① 회원은 회원정보관리를 통해 언제든지 자신의 정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 아이디 등은 수정이 불가능합니다."), _c('br'), _vm._v("\n        ② 회원은 이용신청 시 기재한 사항이 변경되었을 때에는 온라인으로 변경사항을 수정하여야 합니다."), _c('br'), _vm._v("\n        ③ 제2항의 변경사항을 재단에 알리지 않아 발생한 불이익에 대하여 재단은 책임지지 않습니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        [제 4 장 계약당사자의 의무]"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 12 조 (개인정보 보호) "), _c('br'), _vm._v("\n        ① 재단은 회원 가입 시 회원 서비스 제공 이행에 필요한 최소한의 정보를 수집합니다."), _c('br'), _vm._v("\n        ② 재단은 회원의 개인 식별이 가능한 정보를 수집하는 때에는 반드시 당해 이용자의 동의를 받습니다.(회원가입 약관을 읽고 \"동의함\"버튼을 누른 후 회원 본인이 직접 신청서를 작성하시면 이 약관에\n        동의한 것으로 간주합니다.)"), _c('br'), _vm._v("\n        ③ 제공된 개인정보는 다음의 경우를 제외하고는 회원의 동의 없이 이용할 수 없으며 제3자에게 제공하지 않습니다. "), _c('br'), _vm._v("\n        1. 관계 법령에 의하여 수사상의 목적으로 관계기관으로부터 요구가 있는 경우"), _c('br'), _vm._v("\n        2. 방송통신심의위원회의 요청이 있는 경우"), _c('br'), _vm._v("\n        3. 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우"), _c('br'), _vm._v("\n        ④ 회원가입에 대한 동의 철회, 열람 또는 정정 요구 등 회원이 수정한 정보는 수정절차가 완료된 시점부터 바로 적용됩니다."), _c('br'), _vm._v("\n        ⑤ 개인정보의 수집 목적 또는 제공받은 목적이 달성되면, 개인정보를 즉시 파기합니다. 단, 별도 탈퇴 신청없이 통합회원만 탈퇴한 경우 및 상법 등 법령의 규정에 의하여 보존할 필요성이 있는 경우에는\n        예외로 합니다."), _c('br'), _vm._v("\n        ⑥ 재단은 개인정보 보호와 관련하여 이용자의 의견과 불만을 접수할 수 있는 창구를 개설하고 있습니다. 개인정보와 관련한 불만이 있으신 분은 재단 개인정보보호 책임자 또는 개인정보보호 담당자에게\n        의견을 주시면 접수 즉시 조치하여 처리결과를 통보하여 드립니다."), _c('br'), _vm._v("\n        - 서울시50플러스재단 개인정보보호책임자:경영기획본부 이민정 본부장(mjl@50plus.or.kr) T.02-460-5001 "), _c('br'), _vm._v("\n        - 서울시50플러스재단 개인정보보호담당자:정보화지원팀 김정현 주임(jhkim@50plus.or.kr) T. 02-460-5062  F. 02-734-8332"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 13 조 (재단의 의무) "), _c('br'), _vm._v("\n        1. 재단은 법령과 이 약관이 금지하거나 공서 양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하는 데 최선을 다하여야 합니다. "), _c('br'), _vm._v("\n        2. 재단은 이용자가 안전하게 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함) 보안에 대하여 최고의 안전 조치를 강구하여 이용자의 정보보안에 최선을 다해야 할 의무가 있습니다. "), _c('br'), _vm._v("\n        3. 재단은 회원이 제기하는 불편, 불만 사항에 대해 정당하다고 판단할 경우 즉시 처리해야 합니다. "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 14 조 (회원의 의무)"), _c('br'), _vm._v("\n        ① 회원은 관계법령, 이 약관의 규정, 이용안내 등 회사가 통지하는 사항을 준수하여야 하며, 기타 재단에 방해되는 행위를 하여서는 안 됩니다. "), _c('br'), _vm._v("\n        ② 가입 신청자가 재단 서비스 가입 절차를 완료하는 순간부터 귀하는 입력한 정보의 비밀을 유지할 책임이 있으며, 회원의 인터넷 ID와 비밀번호를 사용하여 발생하는 모든 결과에 대한 책임은 회원에게\n        있습니다. "), _c('br'), _vm._v("\n        ③ 회원은 ID 및 PASSWORD 등과 같이 서비스 이용에 필요한 정보를 관리할 의무가 있습니다. 회원의 부주의로 분실한 정보에 대해서는 재단이 책임지지 않습니다."), _c('br'), _vm._v("\n        ④ 회원은 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 안 됩니다."), _c('br'), _vm._v("\n        1. 서비스에서 얻은 정보를 재단의 사전 승낙 없이 회원의 이용 이외 목적으로 복제하거나 출판 및 방송 등에 사용하거나 제3자에게 제공하는 행위 "), _c('br'), _vm._v("\n        2. 재단의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 행위 "), _c('br'), _vm._v("\n        3. 정보통신설비의 오동작 및 정보 등의 파괴 혼란을 유발시키는 컴퓨터 바이러스 감염자료를 등록 또는 유포하는 행위 "), _c('br'), _vm._v("\n        4. 범죄와 결부된다고 객관적으로 판단되는 행위 "), _c('br'), _vm._v("\n        5. 재단 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위"), _c('br'), _vm._v("\n        6. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서 양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위"), _c('br'), _vm._v("\n        7. 기타 관계법령이나 재단이 정한 이용조건에 위배되는 행위 "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 15 조 (회원에 대한 통지)"), _c('br'), _vm._v("\n        ① 재단이 회원에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 서비스 내 전자우편주소 등으로 할 수 있습니다."), _c('br'), _vm._v("\n        ② 재단은 회원 전체에 대한 통지의 경우 7일 이상 재단 홈페이지의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        [제 5 장 서비스의 이용]"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 16 조 (정보의 제공) "), _c('br'), _vm._v("\n        ① 재단이 회원에게 제공하는 서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다."), _c('br'), _vm._v("\n        ② 재단은 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 재단은 홈페이지의 게시판 등을\n        통해 사전에 회원에게 해당 내용을 통지합니다. 다만, 재단이 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다."), _c('br'), _vm._v("\n        ③ 재단은 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 회원에게 제공할 수 있습니다. 다만, 회원은 관련법에 따른 거래관련 정보 및 고객문의 등에\n        대한 답변 등을 제외하고는 언제든지 전자우편에 대해서 수신 거부를 할 수 있습니다."), _c('br'), _vm._v("\n        ④ 재단은 서비스의 운영과 관련하여 서비스 화면, 홈페이지, 전자우편 등에 광고를 게재할 수 있습니다. 광고가 게재된 전자우편을 수신한 회원은 수신거절을 재단에게 할 수 있습니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 17 조 (서비스의 변경) "), _c('br'), _vm._v("\n        ① 재단은 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경할 수 있습니다."), _c('br'), _vm._v("\n        ② 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 등을 그 변경 전에 홈페이지에 게시판에 게시하여야 합니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 18조 (서비스 이용/이용대금)"), _c('br'), _vm._v("\n        ① 이용자가 서비스를 이용하기 위해서는 재단이 공지사항에 게시하거나 해당서비스 이용안내에서 제시하는 절차와 내용을 준수하여야 합니다. 서비스이용신청은 반드시 실명으로 하여야 합니다. "), _c('br'), _vm._v("\n        ② 서비스 이용대금은 재단이 공지사항에 게시하거나 해당 서비스 이용안내에서 제시하는 바에 따릅니다. 재단이 제공하는 서비스는 그 이용대금을 별도 게시하거나 제시하지 않는 한 무료로 합니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 19조 (서비스 이용계약의 성립)"), _c('br'), _vm._v("\n        ① 서비스 이용계약은 이용자의 서비스 이용 신청 시 성립합니다. 다만 아래의 경우 재단은 서비스 이용 계약을 취소할 수 있습니다. "), _c('br'), _vm._v("\n        1. 신청 내용에 허위, 기재누락, 오기가 있는 경우"), _c('br'), _vm._v("\n        2. 기타 서비스를 제공하는 것이 \"서울시50플러스재단\"의 기술상 현저히 지장이 있다고 판단하는 경우"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 20 조 (회원의 게시물) "), _c('br'), _vm._v("\n        ① 재단은 회원이 게시하거나 등록하는 서비스의 내용물이 다음 각 항에 해당한다고 판단되는 경우에 사전통지 없이 삭제할 수 있습니다."), _c('br'), _vm._v("\n        1. 다른 회원 또는 제3자를 비방하거나 중상모략으로 명예를 손상시키는 경우"), _c('br'), _vm._v("\n        2. 공공질서 및 미풍양속에 위반되는 경우"), _c('br'), _vm._v("\n        3. 범죄적 행위에 결부된다고 인정되는 경우"), _c('br'), _vm._v("\n        4. 재단의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 경우"), _c('br'), _vm._v("\n        5. 재단에서 규정한 게시기간을 초과한 경우"), _c('br'), _vm._v("\n        6. 회원이 재단(홈페이지)의 게시판에 음란물을 게재하거나 음란사이트를 링크하는 경우"), _c('br'), _vm._v("\n        7. 기타 관계법령에 위반된다고 판단되는 경우"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 21 조 (게시물의 저작권) "), _c('br'), _vm._v("\n        ① 게시물에 대한 권리와 책임은 게시자에게 있으며, 재단은 게시자의 동의 없이는 이를 사이트 내 게재 이외의 영리목적으로 사용할 수 없습니다. 단, 비영리적인 경우에는 그러하지 아니하며 또한 재단은\n        사이트 내의 게재권을 갖습니다."), _c('br'), _vm._v("\n        ② 회원이 서비스 내에 게시하는 게시물은 검색결과 내지 서비스 및 관련 프로모션 등에 노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정, 복제, 편집되어 게시될 수 있습니다. 이\n        경우, 재단은 저작권법 규정을 준수하며, 회원은 언제든지 고객센터 또는 서비스 내 관리기능을 통해 해당 게시물에 대한 삭제, 검색결과 제외 등의 조치를 취할 수 있습니다."), _c('br'), _vm._v("\n        ③ 회원은 서비스를 이용하여 얻은 정보를 가공, 판매하는 등 서비스에 게재된 자료를 상업적으로 사용할 수 없습니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        [제 6 장 기 타]"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 22 조 (손해배상)"), _c('br'), _vm._v("\n        ① 재단은 무료로 제공되는 서비스 이용과 관련하여 회원에게 어떠한 손해가 발생하더라도 동 손해가 재단의 중대한 과실에 의한 경우를 제외하고 이에 대하여 책임을 부담하지 않습니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 23 조 (면책조항)"), _c('br'), _vm._v("\n        ① 재단은 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다."), _c('br'), _vm._v("\n        ② 재단은 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다."), _c('br'), _vm._v("\n        ③ 재단은 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖에 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다."), _c('br'), _vm._v("\n        ④ 재단은 회원이 게재한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 관해서는 책임을 지지 않습니다."), _c('br'), _vm._v("\n        ⑤ 회원이 발송한 메일 내용에 대한 법적인 책임은 이용자에게 있습니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        제 24 조 (관할법원)"), _c('br'), _vm._v("\n        본 서비스와 관련되는 분쟁에 대해 소송이 제기될 경우, 재단의 본사 소재지를 관할하는 법원을 전속 관할법원으로 합니다."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        - 부 칙 -"), _c('br'), _vm._v("\n        이 약관은 2017년 11월 25일부터 시행합니다."), _c('br'), _vm._v("\n        최종 갱신일 : 2026년 10월 02일"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        ※ 귀하께서는 이용약관에 거부할 권리가 있습니다."), _c('br'), _vm._v("\n        ○ 거부에 따른 불이익 : 동의를 거부하실 경우 회원가입이 불가능함을 알려드립니다.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "privacyAgree"
    }
  }, [_c('span', [_c('strong', [_vm._v("[필수] 개인정보 수집 및 이용 동의(필수사항)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-wrap mt-16"
  }, [_c('strong', [_vm._v("[수집・이용하려는 개인정보의 항목]")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[필수]")]), _vm._v(" 성명, 성별, 생년월일, 아이디, 주소, 연락처, e-mail주소, 나의 관심50+"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[개인정보의 수집・이용 목적]")]), _c('br'), _vm._v("\n        ・회원관리 및 양질의 서비스 제공 및 민원사무 처리"), _c('br'), _vm._v("\n        (교육 운영을 위한 신청자관리, CRM 및 만족도조사 업무수행)"), _c('br'), _vm._v("\n        ・관리시스템(일자리, 수강, 커뮤니티, 대관, 상담) 이용신청서 접수 및 심사"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[개인정보 이용 및 보유기간]")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold"
    }
  }, [_vm._v("회원 탈퇴 시 까지")]), _c('br'), _vm._v("\n        ※ 귀하께서는 개인정보 제공 및 활용에 거부할 권리가 있습니다."), _c('br'), _vm._v("\n        ○ 거부에 따른 불이익 : 동의를 거부하실 경우 회원가입이 불가능함을 알려드립니다.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "privacyAgree2"
    }
  }, [_c('span', [_c('strong', [_vm._v("[선택] 개인정보 수집 및 이용 동의 (선택사항, 동의거부 가능)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-wrap mt-16"
  }, [_c('strong', [_vm._v("[수집·이용하려는 개인정보의 항목]")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[선택]")]), _vm._v(" 성명, 성별, 생년월일, 아이디, 이메일 주소, 연락처, 발송 동의여부"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[개인정보의 수집·이용 목적]")]), _c('br'), _vm._v("\n        ・ 웹 소식지 발송"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[개인정보 이용 및 보유기간]")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold"
    }
  }, [_vm._v("회원 탈퇴 시")]), _c('br'), _vm._v("\n        ※ 귀하께서는 개인정보 제공 및 활용에 거부할 권리가 있습니다."), _c('br'), _vm._v("\n        ○ 거부에 따른 불이익 : 일자리, 교육, 행사 소식 등 정보 제공이 불가능함을 알려드립니다.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "privacyAgree3"
    }
  }, [_c('span', [_c('strong', [_vm._v("[선택] 개인정보 수집 및 이용 동의 (선택사항, 동의거부 가능)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-wrap mt-16"
  }, [_c('strong', [_vm._v("[수집·이용하려는 개인정보의 항목]")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[선택]")]), _vm._v(" 성명, 성별, 생년월일, 아이디, 이메일 주소, 연락처, 발송 동의여부"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[개인정보의 수집·이용 목적]")]), _c('br'), _vm._v("\n        ・ ‘일자리, 교육, 행사소식 등 정보제공’을 위한 문자, 카카오톡 메시지 발송"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[개인정보 이용 및 보유기간]")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold"
    }
  }, [_vm._v("회원 탈퇴 시")]), _c('br'), _vm._v("\n        ※ 귀하께서는 개인정보 제공 및 활용에 거부할 권리가 있습니다."), _c('br'), _vm._v("\n        ○ 거부에 따른 불이익 : 일자리, 교육, 행사 소식 등 정보 제공이 불가능함을 알려드립니다.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "privacyAgree4"
    }
  }, [_c('span', [_c('strong', [_vm._v("[선택] 개인정보 수집 및 이용 동의 (선택사항, 동의거부 가능)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-wrap mt-16"
  }, [_c('strong', [_vm._v("[수집·이용하려는 개인정보의 항목]")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[선택]")]), _vm._v(" 가입경로, 가입동기 및 희망분야, 사진 이용자의 사용언어, 브라우저 종류 및 OS, 화면 색상 및 크기, 방문일시"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[개인정보의 수집·이용 목적]")]), _c('br'), _vm._v("\n        ・ 교육 운영을 위한 신청자 관리, CRM 및 만족도 조사 업무수행"), _c('br'), _vm._v("\n        ・ 관리시스템 이용신청서 접수 및 심사"), _c('br'), _vm._v("\n        (일자리, 수강, 커뮤니티, 대관, 상담)"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[개인정보 이용 및 보유기간]")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold"
    }
  }, [_vm._v("회원 탈퇴 시")]), _c('br'), _vm._v("\n        ※ 귀하께서는 개인정보 제공 및 활용에 거부할 권리가 있습니다."), _c('br'), _vm._v("\n        ○ 거부에 따른 불이익 : 일자리, 교육, 행사 소식 등 정보 제공이 불가능함을 알려드립니다.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "thirdPartyAgree"
    }
  }, [_c('span', [_c('strong', [_vm._v("[필수] 개인정보의 제3자 제공 동의")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-wrap mt-16"
  }, [_c('strong', [_vm._v("[제공되는 개인정보 항목]")]), _c('br'), _vm._v("\n        ・성명, 성별, 생년월일, 아이디, 주소, 연락처, e-mail주소, 나의 관심50+"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[개인정보를 제공 받는 자]")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold"
    }
  }, [_vm._v("・서울특별시 및 시민만족도조사 용역 수행기관, 노원50+센터, 동작50+센터, 서대문50+센터\n        , 성북50+센터, 금천50+센터, 강서50+센터, 서초50+센터, 강동50+센터, 양천50+센터, 성동50+센터, 강북50+센터, 관악50+센터, 동대문50+센터, 용산50+센터")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[개인정보를 제공 받는 자의 개인정보 이용목적]")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold"
    }
  }, [_vm._v("・회원관리 및 양질의 서비스 제공 및 민원사무 처리"), _c('br'), _vm._v("\n          (교육 운영을 위한 신청자관리, CRM 및 만족도조사 업무수행)"), _c('br'), _vm._v("\n          ・관리시스템(일자리, 수강, 커뮤니티, 대관, 상담) 이용신청서 접수 및 심사")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[개인정보를 제공 받는 자의 개인정보 이용 및 보유기간]")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold"
    }
  }, [_vm._v("회원 탈퇴 시 까지")]), _c('br'), _vm._v("\n        ※ 귀하께서는 개인정보 제공 및 활용에 거부할 권리가 있습니다."), _c('br'), _vm._v("\n        ○ 거부에 따른 불이익 : 동의를 거부하실 경우 회원가입이 불가능함을 알려드립니다.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "resumeAgree"
    }
  }, [_c('span', [_c('strong', [_vm._v("[필수] 나의 이력서 정보 제공 동의")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-wrap mt-16"
  }, [_c('strong', [_vm._v("[수집항목]")]), _c('br'), _vm._v("\n        ・기본정보(이름, 생년월일, 이메일, 휴대폰, 주소), 학력(최종학력,졸업여부)"), _c('br'), _vm._v("\n        ・이력서 작성 시 추가 작성한 항목"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[수집 및 이용목적]")]), _c('br'), _vm._v("\n        ・이력서 등록을 통한 입사 지원 등 취업활동 서비스 제공, 각종 맞춤형 취업서비스 제공"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("[보관기간]")]), _c('br'), _vm._v("\n        ・회원탈퇴 및 이력서 삭제 시\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "join-info-text"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("별표")]), _vm._v(" "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _vm._v(" 표시는 필수 입력 사항입니다.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('label', {
    attrs: {
      "for": "loginid"
    }
  }, [_vm._v("아이디")]), _vm._v(" "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(필수입력)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("비밀번호")]), _vm._v(" "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(필수입력)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "join-info-text mt-16",
    attrs: {
      "id": "pw-guide"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("별표")]), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _vm._v(" 비밀번호는 영문(소문자), 숫자, 특수문자 포함 9자 이상 입력해주세요.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('label', {
    attrs: {
      "for": "passwordconfirm"
    }
  }, [_vm._v("비밀번호 확인")]), _vm._v(" "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(필수입력)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("이름")]), _vm._v(" "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(필수입력)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row",
      "id": "label-birth"
    }
  }, [_vm._v("생년\n          "), _c('br', {
    staticClass: "mo-only"
  }), _vm._v("\n          월일 "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(필수입력)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row",
      "id": "label-gender"
    }
  }, [_vm._v("성별 "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(필수입력)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('label', {
    attrs: {
      "for": "email1"
    }
  }, [_vm._v("이메일")]), _vm._v(" "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(필수입력)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row",
      "id": "label-phone"
    }
  }, [_vm._v("휴대폰 "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(필수입력)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('label', {
    attrs: {
      "for": "postcode"
    }
  }, [_vm._v("주소 "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(필수입력)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('label', {
    attrs: {
      "for": "joinChannel"
    }
  }, [_vm._v("가입경로")]), _vm._v(" "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(필수입력)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('label', {
    attrs: {
      "for": "joinMotive"
    }
  }, [_vm._v("가입동기 및"), _c('br'), _vm._v("희망분야")]), _vm._v(" "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(필수입력)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row",
      "id": "label-interest-orgs"
    }
  }, [_vm._v("나의"), _c('br', {
    staticClass: "mo-only"
  }), _vm._v(" 관심 50+"), _c('br'), _vm._v("기관 "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(필수입력)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "like-orgs"
    }
  }, [_c('span', [_vm._v("전체")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('label', {
    attrs: {
      "for": "occuPationSelect"
    }
  }, [_vm._v("주된 직업군"), _c('br'), _vm._v("(퇴직자 포함)")]), _vm._v(" "), _c('span', {
    staticClass: "must",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(필수입력)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("*수신에 동의하시면, 맞춤형 정보를 담은"), _c('br'), _vm._v(" 재단의 '월간 든든레터'를 받아보실 수 있습니다.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7b552ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/MemberRegist.vue
// module id = 1518
// module chunks = 6